import { useCallback } from "react";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import { setPublish } from "redux/slices/globalSlice";
import {
  privateDelete,
  privateGet,
  privatePost,
  privatePut,
} from "services/privateRequest";

export const useFormHandler = () => {
  const dispatch = useDispatch()

  const saveDetails = useCallback(async (baseUrl, payload, field, onSuccess) => {
    try {
      const response = await privatePost(baseUrl, payload);
      if (response.data.success) {
        if (onSuccess) {
          onSuccess();
        } else {
          toast.success(`${field} Created Successfully`)
        }
      }
      if (!response) throw new Error("Failed to update");
      return response;

    } catch (error) {
      throw error;
    } finally {
      dispatch(setPublish(false))
    }

  }, []);

  const updateDetails = useCallback(async (baseUrl, id, payload, field) => {
    try {
      const response = await privatePut(baseUrl, id, payload);
      if (response.data.success) {
        toast.success(`${field} Updated Successfully`)
        dispatch(setPublish(false))
      }
      if (!response) throw new Error("Failed to update");
      return response;
    } catch (error) {
      throw error;
    }
  }, []);

  const deleteDetails = useCallback(async (baseUrl, id, field, message = "Are you sure you want to delete this") => {
    try {
      if (window.confirm(`${message} ${field}?`)) {
        const response = await privateDelete(baseUrl, id);
        if (response.data.statusCode == 200) {
          toast.success(`${field} Deleted Successfully`)
        }
        if (!response) throw new Error("Failed to update");
        return response;
      } else return
    } catch (error) {
      throw error;
    } finally {
      dispatch(setPublish(false))
    }
  }, []);

  const getDetails = useCallback(async (baseUrl, id) => {
    try {
      const response = await privateGet(`${baseUrl}/${id}`);
      // console.log("get: ", response);
      return response?.data?.data || {};
    } catch (error) {
      throw error;
    } finally {
      dispatch(setPublish(false))

    }
  }, []);

  return {
    saveDetails,
    updateDetails,
    deleteDetails,
    getDetails,
  };
};
